<div [ngClass]="'table-of-content--' + area | lowercase" class="table-of-content">
  <div class="table-of-content__container">
    <div class="table-of-content__grid">
      <div>
        <header *ngIf="currentYear$ | async as currentYear" class="table-of-content__header table-of-content__header--year">
          <h1>{{ currentYear }}</h1>
        </header>
      </div>

      <div>
        <header class="table-of-content__header">
          <h1>Learn a language abroad</h1>
          <h4>With Kaplan International Languages</h4>
        </header>

        <div class="table-of-content__body">
          <div class="table-of-content__body__heading">Prices, Dates, and Terms & Conditions</div>
          <div class="table-of-content__body__subheading">Why choose Kaplan?</div>
          <div class="table-of-content__body__content">
            <div
              *ngFor="let tableOfContent of completeTableOfContents$ | async; let i = index"
              [ngClass]="'table-of-content__body__content__block--' + i"
              class="table-of-content__body__content__block"
            >
              <div class="table-of-content__body__content__block__title">{{ tableOfContent.title }}</div>
              <div *ngFor="let item of tableOfContent.items" class="table-of-content__body__content__block__item">{{ item }}</div>
            </div>
          </div>
        </div>

        <div class="table-of-content__disclaimer">
          These prices are in the local currency of each destination. For further information about our excellent range of destinations and study programs,
          please see the Kaplan International 2024 worldwide brochure or visit
          <a href="https://www.kaplaninternational.com/">www.kaplaninternational.com.</a> Prices are correct at the time of publishing online (September 2023)
          and are valid for courses starting in 2023/2024. Kaplan has the right to change prices based on tax increases, governmental actions, or other events
          beyond Kaplan's control. Exam fees are not included in exam course prices but are available on request. Details of what course fees include – plus
          further supplements/ deposits (courier, change, materials, housing, etc.) – are listed in the Terms and Conditions and also at
          <a href="https://www.kaplaninternational.com/privacy">www.kaplaninternational.com/privacy.</a>
        </div>
        <!-- Kaplan Disclaimer - Print View -->
        <div class="table-of-content__disclaimer table-of-content__disclaimer--additional">
          Kaplan Languages Group is now part of Inspirit Capital. Use of the Kaplan brand under license.
        </div>
      </div>
    </div>
  </div>

  <div class="table-of-content__footer">
    <img [src]="footerImagePath" alt="footer" />
  </div>
</div>
